import { ListedProductConnectionFragmentApi } from 'graphql/generated';

export const mergeProductEdges = (
    previousProductEdges?: ListedProductConnectionFragmentApi['edges'],
    newProductEdges?: ListedProductConnectionFragmentApi['edges'],
) => [...(previousProductEdges || []), ...(newProductEdges || [])];
